import React, { useState, useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import {
  addEventConsumptionV2,
  getPublicEventDetails,
  uploadWeFixInviteeTemplates,
} from "./apiService";
import EmissionPopup from "./EmissionPopup";
import Lottie from "lottie-react";
import car from "./assets/car.json";
import bus from "./assets/bus.json";
import train from "./assets/train.json";
import flight from "./assets/flight.json";
import ecologo from "./assets/ecologo.png";
import Arrow from "./assets/Arrow.png";
import mealll from "./assets/mealll.png";
import nonVeg from "./assets/nonVeg.png";
import Vegan from "./assets/vegan.png";
import "./AddInformation.css";
import ReactSpeedometer from "react-d3-speedometer";
import {
  Document,
  Page,
  Text,
  View,
  Image,
  StyleSheet,
  pdf,
  Font,
} from "@react-pdf/renderer";
import certificate from "./assets/EO.png";
import co2 from "./assets/Sign_C.jpeg";

function EUKids() {
  const [searchParams] = useSearchParams();
  const eventId = 161;
  const [eventDetails, setEventDetails] = useState({});
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [travelMode, setTravelMode] = useState("Car");
  const [fuelOptions, setFuelOptions] = useState([
    "Petrol",
    "Diesel",
    "Electric",
    "CNG",
  ]);

  const [FuelMode, setFuelMode] = useState("Petrol");
  const [MealMode, setMealMode] = useState("Veg");
  const [endLocation, setEndLocation] = useState("");
  const [stayDays, setStayDays] = useState(1);
  const [startingLocation, setStartingLocation] = useState("");
  const [eventName, setEventName] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const locationRef = useRef(null);
  const [location, setLocation] = useState("");
  const [loading, setLoading] = useState(true);
  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [alertType, setAlertType] = useState("success");
  const [error, setError] = useState(null);
  const [totalEmission, setTotalEmission] = useState(null);
  const [mealProvided, setMealProvided] = useState("");
  const [mealType, setMealType] = useState("");
  const [formData, setFormData] = useState({
    eventDuration: "0", // default to 0
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  Font.register({
    family: "Ubuntu",
    fonts: [
      {
        src: "https://fonts.gstatic.com/s/questrial/v13/QdVUSTchPBm7nuUeVf7EuStkm20oJA.ttf",
      },
      {
        src: "https://fonts.gstatic.com/s/questrial/v13/QdVUSTchPBm7nuUeVf7EuStkm20oJA.ttf",
        fontWeight: "bold",
      },
      {
        src: "https://fonts.gstatic.com/s/questrial/v13/QdVUSTchPBm7nuUeVf7EuStkm20oJA.ttf",
        fontWeight: "normal",
        fontStyle: "italic",
      },
    ],
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevState) => {
      let newFormData = { ...prevState, [name]: value };

      if (name === "eventDuration") {
        newFormData.eventDuration = value;
      }

      return newFormData;
    });
  };

  // Hard-coded accommodationId
  const accommodationId = 3;

  useEffect(() => {
    if (eventId) {
      const fetchEventDetails = async () => {
        try {
          const data = await getPublicEventDetails(eventId);
          console.log("Fetched Event Details:", data); // Log the data to check eventName
          setEventDetails(data);
          setEventName(data.eventName || "");
          setStartDate(data.eventStartDate || "");
          setEndDate(data.eventEndDate || "");
          setEndLocation(data.location || "");
          setMealProvided(data.mealProvided || false);
          setMealType(data.mealType || "");
        } catch (error) {
          setError("Failed to fetch event details");
        } finally {
          setLoading(false);
        }
      };
      fetchEventDetails();
    } else {
      setError("Event ID is missing");
      setLoading(false);
    }
  }, [eventId]);

  // Function to calculate the difference in days
  const calculateDaysDifference = (start, end) => {
    const startDay = new Date(start);
    const endDay = new Date(end);

    // Calculate the difference in milliseconds
    const difference = endDay - startDay;

    // Convert milliseconds to days
    return Math.max(0, Math.floor(difference / (1000 * 60 * 60 * 24)));
  };
  const handleDaysChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  useEffect(() => {
    if (startDate && endDate) {
      // Calculate the number of days between startDate and endDate
      const days = calculateDaysDifference(startDate, endDate);

      // Create a mapping for the event duration
      const newDurationMapping = {};
      for (let i = 0; i <= days + 1; i++) {
        newDurationMapping[i] = i;
      }
      setEventDurationMapping(newDurationMapping);
    }
  }, [startDate, endDate]);
  const [eventDurationMapping, setEventDurationMapping] = useState({ 0: 0 });

  const getIds = () => {
    const mealPreferences = { Veg: 6, "Non-Veg": 7, Vegan: 8 };
    const travelModes = {
      "Car-Diesel": 1,
      "Car-Petrol": 2,
      "Car-CNG": 3,
      "Car-Electric": 4,
      "Bus-Fuel-Based": 5,
      "Train-Train": 6,
      "Bus-Electric": 7,
      "Flight-Economy": 8,
      "Flight-Business": 13,
    };
    const fuelCombined = `${travelMode}-${FuelMode}`;

    return {
      mealPreferenceId: mealPreferences[MealMode],
      travelModeId: travelModes[fuelCombined],
      fuelModeId: fuelCombined,
    };
  };

  const handleTravelChange = (event) => {
    const selectedMode = event.target.value;
    setTravelMode(selectedMode);

    let defaultFuelMode = "";
    let defaultMealMode = mealProvided ? "Veg" : "";

    switch (selectedMode) {
      case "Bus":
        setFuelOptions(["Fuel-Based", "Electric"]);
        defaultFuelMode = "Fuel-Based";
        break;
      case "Train":
        setFuelOptions(["Train"]);
        defaultFuelMode = "Train";
        break;
      case "Flight":
        setFuelOptions(["Economy", "Business"]);
        defaultFuelMode = "Economy";
        break;
      default:
        setFuelOptions(["Petrol", "Diesel", "Electric", "CNG"]);
        defaultFuelMode = "Petrol";
    }

    setFuelMode(defaultFuelMode);

    // Reset MealMode correctly based on mealProvided
    if (mealProvided) {
      setMealMode(defaultMealMode); // Set Veg by default if meal is provided
    } else {
      setMealMode(""); // Clear meal mode if meal is not provided
    }
  };

  const handleFuelChange = (event) => {
    setFuelMode(event.target.value);
  };

  const handleMealChange = (event) => {
    setMealMode(event.target.value);
  };
  const [placeSelected, setPlaceSelected] = useState(false);
  useEffect(() => {
    const initializeAutocomplete = () => {
      const locationInput = locationRef.current;

      const autocomplete = new window.google.maps.places.Autocomplete(
        locationInput,
        {
          strictBounds: false,
        }
      );

      autocomplete.setFields([
        "formatted_address",
        "geometry.location",
        "name",
        "place_id",
      ]);

      autocomplete.addListener("place_changed", () => {
        const place = autocomplete.getPlace();
        if (!place.geometry || !place.geometry.location) {
          setPlaceSelected(false); // Set placeSelected to false
          return;
        }

        setPlaceSelected(true); // Set placeSelected to true when a valid place is selected
        setStartingLocation(place.formatted_address);
        setLocation(place.formatted_address);
        console.log("Selected place:", place.formatted_address);
      });
    };

    if (window.google && window.google.maps) {
      initializeAutocomplete();
    } else {
      const script = document.createElement("script");
      script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyCpdevcXjKt9CVD1n8chB59MGW0d1uT2dg&libraries=places`;
      script.async = true;
      script.defer = true;
      script.onload = initializeAutocomplete;
      document.head.appendChild(script);
    }
  }, []);

  const handleSendCertificate = async () => {
    try {
      const pdfDoc = generatePDF();
      const pdfBlob = await pdf(pdfDoc).toBlob();
      console.log(name);
      console.log(email);
      const formData = new FormData();
      formData.append("[0].UserName", name);
      formData.append("[0].UserEmail", email);
      formData.append("[0].FileData", pdfBlob, `${name}-certificate.pdf`);

      // console.log("Certificate FormData contents:");
      // for (let pair of formData.entries()) {
      //   console.log(pair[0] + ": " + pair[1]);
      // }

      const response = await uploadWeFixInviteeTemplates(formData);

      if (!response || response.status === false) {
        console.error("Certificate upload failed:", response);
        throw new Error(
          `Certificate upload failed: ${response?.message || "Unknown error"}`
        );
      }

      console.log("Certificate uploaded successfully.");
      //Here are the cases for different email domains.
      const emailDomain = email.split("@")[1];
      let emailLink = "";

      if (emailDomain === "gmail.com") {
        emailLink = "https://mail.google.com/mail/";
      } else if (emailDomain === "yahoo.com") {
        emailLink = "https://mail.yahoo.com/";
      } else if (
        emailDomain === "outlook.com" ||
        emailDomain === "hotmail.com"
      ) {
        emailLink = "https://outlook.live.com/mail/";
      } else {
        emailLink = "mailto:";
      }

      setAlertMessage(
        <div>
          <h4 style={{ fontFamily: "Quicksand", fontSize: "16.5px" }}>
            🎉 Your certificate has been sent!
            <a
              href={emailLink}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "#fff",
                textDecoration: "underline",
                cursor: "pointer",
                marginLeft: "8px",
                display: "inline-block",
              }}
            >
              Check your inbox →
            </a>
          </h4>
        </div>
      );
      setAlertType("success");
      setShowAlert(true);
    } catch (error) {
      console.error("Error during certificate generation/upload:", error);
      setAlertMessage(
        "Oops! We couldn't send your certificate. Please try again."
      );
      setAlertType("error");
      setShowAlert(true);
    }
  };

  const handleSubmit = async () => {
    // Validation for email and name
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const nameRegex = /^[a-zA-Z\s]*$/;

    if (!emailRegex.test(email)) {
      setAlertMessage("Please enter a correct Email ID");
      setAlertType("error");
      setShowAlert(true);
      return;
    }

    if (name.trim() === "") {
      setAlertMessage("Name is required");
      setAlertType("error");
      setShowAlert(true);
      return;
    } else if (!nameRegex.test(name)) {
      setAlertMessage("Name can only contain letters and spaces");
      setAlertType("error");
      setShowAlert(true);
      return;
    }

    const { mealPreferenceId, travelModeId, fuelModeId } = getIds();

    if (!travelModeId || !fuelModeId) {
      setAlertMessage(
        "Please select meal preference, travel mode, and fuel mode"
      );
      setAlertType("error");
      setShowAlert(true);
      return;
    }

    // Add the placeSelected check here
    if (!stayDays || !placeSelected || !accommodationId || !eventId) {
      setAlertMessage(
        "All fields must be filled, and location must be selected from suggestions."
      );
      setAlertType("error");
      setShowAlert(true);
      return;
    }

    // Conditionally set mealPreferenceId based on mealProvided
    const finalMealPreferenceId = mealProvided ? mealPreferenceId : 9;

    if (!mealProvided) {
      if (!formData.eventDuration || isNaN(Number(formData.eventDuration))) {
        setAlertMessage("Please enter a valid number for Stay Days");
        setAlertType("error");
        setShowAlert(true);
        return;
      }
    }

    const data = {
      AccommodationId: accommodationId,
      EventId: eventId,
      MealPreferenceId: finalMealPreferenceId,
      StayDays: formData.eventDuration ? Number(formData.eventDuration) : null,
      TravelModeId: travelModeId,
      UserEmail: email,
      UserName: name,
      Location: {
        Location: startingLocation,
        TransportationType: travelModeId,
      },
    };

    try {
      setIsSubmitting(true);
      console.log("Sending data:", data);

      const response = await addEventConsumptionV2(data);
      console.log("Data saved successfully:", response);

      const emissionValue = response.totalCarbonEmission?.result || 0;
      const roundedEmission = parseFloat(emissionValue).toFixed(2);
      console.log("Rounded Total Emission:", roundedEmission);

      setTotalEmission(roundedEmission);

      setAlertMessage("Data saved successfully");
      setAlertType("success");
      setShowAlert(true);

      await handleSendCertificate();
    } catch (error) {
      console.error("Error:", error);
      setAlertMessage("Error processing your request");
      setAlertType("error");
      setShowAlert(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCloseAlert = () => {
    setShowAlert(false);
  };

  const getAnimation = () => {
    switch (travelMode) {
      case "Bus":
        return <Lottie animationData={bus} className="bus" />;
      case "Train":
        return <Lottie animationData={train} className="train-im" />;
      case "Flight":
        return <Lottie animationData={flight} className="flight" />;
      default:
        return <Lottie animationData={car} className="car" />;
    }
  };

  const [dimensions, setDimensions] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const handleResize = () => {
      setDimensions({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isSmallScreen = dimensions.width < 768;
  const isVerySmallScreen = dimensions.width < 480;

  const extractCityStateCountry = (address) => {
    if (!address) return "N/A";
    const parts = address.split(",").slice(-3);
    return parts.join(", ").trim();
  };

  const getCurrentDate = () => {
    const date = new Date();
    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "long" });
    const year = date.getFullYear();

    const ordinal = (d) => {
      if (d > 3 && d < 21) return "th";
      switch (d % 10) {
        case 1:
          return "st";
        case 2:
          return "nd";
        case 3:
          return "rd";
        default:
          return "th";
      }
    };

    return `${day}${ordinal(day)} ${month} ${year}`;
  };

  const generatePDF = () => {
    return (
      <Document style={styles.doc}>
        <Page size="A4" orientation="landscape" style={styles.page}>
          <View style={styles.view}>
            <Image src={certificate} />
            <Text style={styles.text5}>{name}</Text>
            <Text style={styles.text11}>{getCurrentDate()}</Text>
            <Image style={styles.imgSig} src={co2} />
          </View>
        </Page>
      </Document>
    );
  };

  return (
    <div className="container-add">
      <div className="forms-section-un">
        <img src={ecologo} alt="" />

        {!loading && eventName && <h2 className="event-name">{eventName}</h2>}

        <div className="inputs-group">
          <div className="inputsGroup">
            <input
              type="texxt"
              required
              autoComplete="off"
              className="inputs-box"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            <label htmlFor="name">Name</label>
          </div>
          <div className="inputsGroup">
            <input
              type="email"
              required
              autoComplete="off"
              className="inputs-box"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <label htmlFor="email">Email ID</label>
          </div>
        </div>

        <div className="questions">How will you travel to the Event?</div>
        <div className="radios-group">
          {["Car", "Bus", "Train", "Flight"].map((mode) => (
            <div key={mode} style={{ display: "flex", alignItems: "center" }}>
              <input
                type="checkbox"
                id={mode.toLowerCase()}
                required
                style={{ display: "none" }}
                name="travel"
                value={mode}
                checked={travelMode === mode}
                onChange={handleTravelChange}
              />
              <label
                htmlFor={mode.toLowerCase()}
                className="check"
                style={{ marginRight: "8px" }}
              >
                <svg width="18px" height="18px" viewBox="0 0 18 18">
                  <path d="M1,9 L1,3.5 C1,2 2,1 3.5,1 L14.5,1 C16,1 17,2 17,3.5 L17,14.5 C17,16 16,17 14.5,17 L3.5,17 C2,17 1,16 1,14.5 L1,9 Z"></path>
                  <polyline points="1 9 7 14 15 4"></polyline>
                </svg>
              </label>
              <span>{mode}</span>
            </div>
          ))}
        </div>

        <div className="questions">Type of Transportation:</div>
        <div className="radios-group1">
          {fuelOptions.map((option) => {
            const optionId = option.replace(/\s+/g, "-").toLowerCase();

            return (
              <div
                key={optionId}
                style={{ display: "flex", alignItems: "center" }}
              >
                <input
                  type="checkbox"
                  id={optionId}
                  style={{ display: "none" }}
                  name="fuel"
                  value={option}
                  checked={FuelMode === option}
                  onChange={handleFuelChange}
                  required
                />
                <label
                  htmlFor={optionId}
                  className={`check ${optionId}`}
                  style={{ marginRight: "8px", marginTop: "-2px" }}
                >
                  <svg width="18px" height="18px" viewBox="0 0 18 18">
                    <path d="M1,9 L1,3.5 C1,2 2,1 3.5,1 L14.5,1 C16,1 17,2 17,3.5 L17,14.5 C17,16 16,17 14.5,17 L3.5,17 C2,17 1,16 1,14.5 L1,9 Z"></path>
                    <polyline points="1 9 7 14 15 4"></polyline>
                  </svg>
                </label>
                <span>{option}</span>
              </div>
            );
          })}
        </div>

        <div className="questions">Location:</div>

        <div className="questions">
          <span className="locations-icon">
            {" "}
            <i class="fa fa-map-marker" style={{ color: "#D90166" }}></i>
          </span>

          <input
            className="inpuut"
            placeholder="Location"
            ref={locationRef}
            value={startingLocation}
            required
            onChange={(e) => setStartingLocation(e.target.value)}
          />
        </div>

        <div className="questions-duration">Duration of stay in hotel:</div>

        <div className="duration-container">
          <div className="dropdown-wrapper">
            <select
              id="eventDuration"
              name="eventDuration"
              value={formData.eventDuration}
              onChange={handleChange}
              required
            >
              {Object.values(eventDurationMapping).map((duration) => (
                <option key={duration} value={duration}>
                  {duration}
                </option>
              ))}
            </select>
            <span className="night-text">
              Night{formData.eventDuration > 1 ? "s" : ""}
            </span>
          </div>
        </div>

        {mealProvided && (
          <>
            <div className="questions">Meal Preference:</div>
            <div className="radios-group2">
              {/* Define the meal options based on mealType */}
              {["Veg", "Non-Veg", "Vegan"]
                .filter((meal) => {
                  // Only show the options based on mealType
                  if (mealType === "Veg") {
                    return meal === "Veg";
                  } else if (mealType === "Veg|Alcohol") {
                    return meal === "Veg";
                  } else if (mealType === "NonVeg") {
                    return meal === "Non-Veg";
                  } else if (mealType === "NonVeg|Alcohol") {
                    return meal === "Non-Veg";
                  } else if (mealType === "Vegan") {
                    return meal === "Vegan";
                  } else if (mealType === "Vegan|Alcohol") {
                    return meal === "Vegan";
                  } else if (mealType === "Veg|NonVeg") {
                    return meal === "Veg" || meal === "Non-Veg";
                  } else if (mealType === "Veg|NonVeg|Alcohol") {
                    return meal === "Veg" || meal === "Non-Veg";
                  } else if (mealType === "Veg|Vegan|Alcohol") {
                    return meal === "Veg" || meal === "Vegan";
                  } else if (mealType === "Veg|Vegan") {
                    return meal === "Veg" || meal === "Vegan";
                  } else if (mealType === "NonVeg|Vegan") {
                    return meal === "Non-Veg" || meal === "Vegan";
                  } else if (mealType === "NonVeg|Vegan|Alcohol") {
                    return meal === "Non-Veg" || meal === "Vegan";
                  } else if (mealType === "Veg|NonVeg|Vegan") {
                    return true; // Show all options
                  } else if (mealType === "Veg|NonVeg|Vegan|Alcohol") {
                    return true; // Show all options
                  }
                  return false; // Default case if none match
                })
                .map((meal) => (
                  <div
                    key={meal}
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <input
                      type="checkbox"
                      id={meal.toLowerCase().replace(/\s+/g, "-")}
                      style={{ display: "none" }}
                      name="Meal"
                      value={meal}
                      checked={MealMode === meal}
                      onChange={handleMealChange}
                      required
                    />
                    <label
                      htmlFor={meal.toLowerCase().replace(/\s+/g, "-")}
                      className="check"
                      style={{ marginRight: "8px" }}
                    >
                      <svg width="18px" height="18px" viewBox="0 0 18 18">
                        <path d="M1,9 L1,3.5 C1,2 2,1 3.5,1 L14.5,1 C16,1 17,2 17,3.5 L17,14.5 C17,16 16,17 14.5,17 L3.5,17 C2,17 1,16 1,14.5 L1,9 Z"></path>
                        <polyline points="1 9 7 14 15 4"></polyline>
                      </svg>
                    </label>
                    <span>{meal}</span>
                  </div>
                ))}
            </div>
          </>
        )}
        <button
          onClick={handleSubmit}
          className="summary-button"
          disabled={isSubmitting}
        >
          {isSubmitting ? (
            <span>
              <i
                className="fa fa-spinner fa-spin"
                style={{ marginRight: "8px" }}
              ></i>
              Processing...
            </span>
          ) : (
            "Submit"
          )}
        </button>
      </div>

      <div className="details-section">
        <h3>
          <span>Travel</span> <br /> Details
        </h3>

        <div className="car-image">{getAnimation()}</div>

        <div className="journey-details">
          <div className="journey-line">
            <span className="start-journey">
              <i class="fa fa-map-marker" style={{ color: "#D90166" }}></i>{" "}
              {extractCityStateCountry(startingLocation)}
            </span>

            <img src={Arrow} alt="" />
            <span className="end-journey">
              <i class="fa fa-map-marker" style={{ color: "green" }}></i>{" "}
              {extractCityStateCountry(endLocation) || "N/A"}
            </span>
          </div>

          <div></div>

          <div className="date-meal">
            <div className="date-meal-details">
              <div className="date-box">
                <div className="start-date-box">
                  <span className="label">START DATE</span>
                  <div className="date">
                    <span className="day">
                      {startDate ? new Date(startDate).getDate() : "14"}
                    </span>
                    <div className="month-year">
                      <span className="month">
                        {startDate
                          ? new Date(startDate).toLocaleString("default", {
                              month: "short",
                            })
                          : "Sep"}
                      </span>
                      <span className="year">
                        {startDate ? new Date(startDate).getFullYear() : "24"}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="end-date-box">
                  <span className="label">END DATE</span>
                  <div className="date">
                    <span className="day">
                      {endDate ? new Date(endDate).getDate() : "16"}
                    </span>
                    <div className="month-year">
                      <span className="month">
                        {endDate
                          ? new Date(endDate).toLocaleString("default", {
                              month: "short",
                            })
                          : "Sep"}
                      </span>
                      <span className="year">
                        {endDate ? new Date(endDate).getFullYear() : "24"}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {mealProvided && MealMode && (
              <div className="meal-type">
                {MealMode === "Veg" && (
                  <img
                    src={mealll}
                    alt="Veg Meal"
                    style={{ width: "55px", height: "auto" }}
                  />
                )}

                {MealMode === "Non-Veg" && (
                  <img
                    src={nonVeg}
                    alt="Non-Veg Meal"
                    style={{ width: "55px", height: "auto" }}
                  />
                )}
                {MealMode === "Vegan" && (
                  <img
                    src={Vegan}
                    alt="Vegan Meal"
                    style={{ width: "55px", height: "auto" }}
                  />
                )}
              </div>
            )}
          </div>
        </div>

        <div className="emission-section">
          <div className="meter">
            <ReactSpeedometer
              width={isSmallScreen ? 160 : 230}
              height={isVerySmallScreen ? 160 : 230}
              needleTransitionDuration={4000}
              needleColor="black"
              value={Math.min(totalEmission || 0, 240)}
              minValue={0}
              maxValue={240}
              segments={3}
              segmentColors={["#4dbce8", "#ffa342", "#f00018"]}
              customSegmentStops={[0, 80, 160, 240]}
              forceRender={true}
              labelFontSize={"0px"}
              ringWidth={isSmallScreen ? 20 : 40}
              valueTextFontSize={"0px"}
            />
          </div>
          <div className="data-list">
            <div className="emission-meter">🍃 TOTAL EMISSION</div>
            <div
              className="emission-value"
              style={{
                color:
                  totalEmission >= 160
                    ? "#f00018"
                    : totalEmission >= 80
                    ? "#ffa342"
                    : "#4dbce8",
              }}
            >
              {totalEmission ? `${totalEmission} Kg CO2` : "Calculating..."}
            </div>
            <div
              className="emission-level"
              style={{
                color:
                  totalEmission >= 160
                    ? "#f00018"
                    : totalEmission >= 80
                    ? "#ffa342"
                    : "#4dbce8",
              }}
            >
              {totalEmission >= 160
                ? "Oops! You exceeded the carbon emissions limit."
                : totalEmission >= 80
                ? "You are within the carbon emissions limit."
                : "Great! You are below the carbon emission limit."}
            </div>
          </div>
        </div>
      </div>

      {showAlert && (
        <EmissionPopup
          message={alertMessage}
          onClose={handleCloseAlert}
          onConfirm={handleCloseAlert}
          totalEmission={totalEmission}
        />
      )}
    </div>
  );
}

const styles = StyleSheet.create({
  page: {
    backgroundColor: "#fff",
    width: "100%",
    flexDirection: "row",
  },
  view: {
    width: "100%",
    height: "100%",
    padding: 0,
    backgroundColor: "white",
  },
  text5: {
    position: "absolute",
    left: "50%",
    width: "50%",
    top: "165px",
    textAlign: "center",
    justifyContent: "center",
    fontSize: 28,
    color: "#07750e",
    fontFamily: "Ubuntu",
    fontWeight: "bold",
  },
  text11: {
    position: "absolute",
    left: "57%",
    width: "50%",
    top: "395px",
    textAlign: "left",
    justifyContent: "left",
    fontSize: 14,
    color: "#07750e",
    fontFamily: "Ubuntu",
    paddingLeft: "10px",
  },
  imgSig: {
    position: "absolute",
    left: "58%",
    top: "440px",
    justifyContent: "left",
    paddingLeft: "10px",
    width: "100px",
    height: "auto",
  },
});

export default EUKids;
